import { Printer } from 'lucide-react'
import { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { CollaboratorsPrintSheet } from '@/components/administration/commitment-matrix/dashboard/collaborators-print-sheet'
import { ResponsiveFormModal } from '@/components/commons'
import { Button } from '@/components/ui/button'
import type { CommitmentMatrixDashboardParams } from '@/types'

interface CollaboratorsPrintModalProps {
	open: boolean
	onClose: () => void
	params: CommitmentMatrixDashboardParams
}

export function CollaboratorsPrintModal({
	open,
	onClose,
	params,
}: CollaboratorsPrintModalProps) {
	const printRef = useRef<HTMLDivElement>(null)
	const handlePrint = useReactToPrint({
		contentRef: printRef,
		documentTitle: 'Matriz de Comprometimento',
		pageStyle: `
			@page {
				size: A4 landscape;
				margin: 12mm 14mm;
			}
			@media print {
				html, body {
					margin: 0 !important;
					padding: 0 !important;
				}
			}
		`,
	})

	return (
		<ResponsiveFormModal
			open={open}
			onOpenChange={(next) => !next && onClose()}
			title="Colaboradores"
			dialogClassName="max-h-[90vh] overflow-y-auto sm:max-w-5xl"
		>
			<div className="flex flex-col gap-4">
				<div className="flex justify-end print:hidden">
					<Button
						type="button"
						size="sm"
						className="gap-1.5 bg-kaefer-medium-grey text-white hover:bg-kaefer-medium-grey/90"
						onClick={() => handlePrint()}
					>
						<Printer className="size-4" />
						Baixar PDF
					</Button>
				</div>

				<div className="overflow-x-auto rounded-lg border border-kaefer-light-silver">
					<CollaboratorsPrintSheet ref={printRef} params={params} />
				</div>
			</div>
		</ResponsiveFormModal>
	)
}
